import * as React from 'react';
import { BenefitModel, ServiceModel } from '../../../../models'
import Controller, { IAbstractDashboardControllerProps } from '../../common/CommonDashboardController';
import View from './BenefitsAddEditView';

interface IBenefitAddEditViewControllerState extends Interfaces.IViewControllerState {
    benefit: BenefitModel
    isNextStepAfterBenefitCreationDialogOpen: boolean
    service: ServiceModel
}

class BenefitAddEditViewController<P, S> extends Controller<P, S & IBenefitAddEditViewControllerState> {

    public static defaultProps: Partial<IAbstractDashboardControllerProps> = {
        title: 'Создание преимущества'
    }

    constructor(props: any) {
        super(props)
        this.state = {
            logicError: '',
            benefit: new BenefitModel(),
            isNextStepAfterBenefitCreationDialogOpen: false
        } as any;
    }

    public async fia_componentWillMount() {
        const benefitId = this.props.history['location']['state'] ? this.props.history['location']['state']['benefitId'] : null;
        const service = this.props.history['location']['state'] ? this.props.history['location']['state']['service'] : null;
        if (benefitId) {
            this.setState({ loading: true });
            let benefit = this.state.benefit;
            try {
                benefit = await BenefitModel.loadBenefit(benefitId);
            } catch (e){/**/}
            this.setState({ loading: false, benefit })
        }
        if (service) {
            this.setState({ service });
        }
    }

    public goBack() {
        const { service, benefit } = this.state;
        if (service) {
            if (benefit.id) {
                service.benefits.push(benefit);
            }
            this.props.history['replace']('/services/add', { service });
        } else {
            super.goBack()
        }
    }

    public onAnotherPost() {
        this.setState({ benefit: new BenefitModel(), isNextStepAfterBenefitCreationDialogOpen: false })
    }

    public async onBenefitSave() {
        const { service, benefit } = this.state;
        this.setState({ loading: true });
        await benefit.saveFullBenefit()
        if (service) {
            this.goBack();
        } else {
            this.setState({ loading: false, isNextStepAfterBenefitCreationDialogOpen: true });
        }
    }

    public onCloseDialog() {
        this.setState({ benefit: this.state.benefit, isNextStepAfterBenefitCreationDialogOpen: false });
    }

    public dashboard_render(): JSX.Element {
        const { benefit, loading, isNextStepAfterBenefitCreationDialogOpen } = this.state;
        return <View
            accessAvailable={this.accessAvailable}
            onAnotherCreation={() => this.onAnotherPost()}
            model={benefit}
            loading={loading}
            onSave={() => this.onBenefitSave()}
            isNextStepAfterCreationDialogOpen={isNextStepAfterBenefitCreationDialogOpen}
            // tslint:disable-next-line:jsx-no-lambda
            onBack={() => this.goBack()}
            onDialogClose={() => this.onCloseDialog()}
        />
    }
}

export default BenefitAddEditViewController;



// WEBPACK FOOTER //
// ./src/app/dashboard/benefits/addedit/BenefitsAddEditViewController.tsx